import ActionFile from './ActionFile.connect';

export default ActionFile;
